export enum CambioEstadoCivilEnum {
  UNDEFINED = 0,
  SINGLE = 1,
  MARRIED = 2,
  SEPARATED = 3,
  WIDOWER = 4,
  FREE_UNION = 5
}

export enum CambioEstadoCivilEnumMap {
  UNDEFINED = "0",
  SINGLE = "1",
  MARRIED = "2",
  SEPARATED = "3",
  WIDOWER = "4",
  FREE_UNION = "5"
}
